
import LazyHydrate from "vue-lazy-hydration"
import components from "@soenergy-aliases/project-content-blocks"
import isVue3 from "../helpers/isVue3"

export default {
  components: {
    LazyHydrate,
    ...components
  },
  inheritAttrs: false,
  props: {
    blocks: {
      required: true,
      type: Array
    },
    tag: {
      type: String,
      default: "div"
    },
    wrapperElementTag: {
      type: String,
      default: null
    },
    wrapperElementAttrs: {
      type: Array,
      default: () => []
    },
    lazyHydrate: {
      type: Boolean,
      default: true
    },
    userSignedIn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVue3() {
      return isVue3()
    },
    existingBlocks() {
      return this.blocks.filter(block => block.component in components)
    },
    visibleBlocks() {
      return this.existingBlocks.map((block, index) => {
        const shouldLazyHydrate =
          block.lazyHydrate || (this.lazyHydrate && index > 1)

        return {
          ...block,
          lazyLoad: block.lazyLoad || null,
          lazyHydrate: shouldLazyHydrate || null,
          deferMediaLoading: block.deferMediaLoading || shouldLazyHydrate
        }
      })
    }
  },
  updated() {
    this.$emit("updated")
  }
}
